import { gql } from '@apollo/client'

export const GET_LOSSSES_SUMAMARY = gql`
  query LossesTotals($dateRange: DateRangeProps) {
    lossesTotals(dateRange: $dateRange) {
      date
      dateFormat {
        format
        interval
      }
      delivered {
        quantity
        gmv
      }
      failed {
        PAYMENT_DENIED {
          quantity
          gmv
        } 
        AUTOMATIC_BLOCKLIST {
          quantity
          gmv
        } 
        AUTOMATIC_ANTIFRAUD {
          quantity
          gmv
        } 
        total {
          quantity
          gmv
        } 
      }
      cancelled {
        CANCELLATION_ACTIVATION_TEST {
          quantity
          gmv
        } 
        CANCELLATION_AREA_NOT_COVERED {
          quantity
          gmv
        } 
        CANCELLATION_DEVELOPMENT_TESTS {
          quantity
          gmv
        } 
        CANCELLATION_GAVE_UP {
          quantity
          gmv
        } 
        CANCELLATION_LACKING_DATA {
          quantity
          gmv
        } 
        CANCELLATION_OTHER {
          quantity
          gmv
        } 
        CANCELLATION_OUT_OF_STOCK {
          quantity
          gmv
        } 
        CANCELLATION_PAST_DELIVERY_TIME {
          quantity
          gmv
        } 
        CANCELLATION_POSSIBLE_FRAUD {
          quantity
          gmv
        } 
        CANCELLATION_WRONG_ADDRESS {
          quantity
          gmv
        } 
        total {
          quantity
          gmv
        } 
      }
    }
  }
`
